import * as React from 'react';

import {ErrorMessage} from 'shells/form/error-message';
import {Label} from 'shells/form/label';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {TextField} from 'shells/textfield/textfield';

import {getHasError} from './helpers';
import type {CardValidation, CardForm} from './types';

import styles from './billing-form.module.css';

type Props = {
    cardForm: CardForm | null | undefined;
    cardValidation: CardValidation | null | undefined;
    onUpdateField: (key: string, value: string) => void;
    isElementCardFocused: boolean;
    requireFields: boolean;
};

export function CreditCardFields(props: Props) {
    const {cardForm, cardValidation, onUpdateField, isElementCardFocused, requireFields} = props;

    return (
        <div className={styles['credit-card-fields']}>
            <StackLegacy spacing={8}>
                <StackLegacy spacing={16}>
                    <div className='flex gap-8 full-width'>
                        <div className='flex-grow'>
                            <Label htmlFor='first_name'>First name</Label>
                            <TextField
                                // @ts-expect-error
                                name='first_name'
                                value={cardForm ? cardForm.first_name : ''}
                                required={props.requireFields}
                                hasError={
                                    requireFields
                                        ? getHasError(cardValidation, 'first_name')
                                        : false
                                }
                                onChange={(value) => onUpdateField('first_name', value)}
                                selectOnFocus={true}
                            />
                        </div>
                        <div className='flex-grow'>
                            <Label htmlFor='last_name'>Last name</Label>
                            <TextField
                                // @ts-expect-error
                                name='last_name'
                                value={cardForm ? cardForm.last_name : ''}
                                required={props.requireFields}
                                hasError={
                                    requireFields ? getHasError(cardValidation, 'last_name') : false
                                }
                                onChange={(value) => onUpdateField('last_name', value)}
                                selectOnFocus={true}
                            />
                        </div>
                    </div>
                    {/* Recurly attaches its native card element here */}
                    <div
                        id='recurly-credit-card-elements'
                        className={isElementCardFocused ? styles['card-element-focused'] : ''}
                    />
                </StackLegacy>
                {requireFields &&
                (getHasError(cardValidation, 'number') ||
                    getHasError(cardValidation, 'month') ||
                    getHasError(cardValidation, 'year') ||
                    getHasError(cardValidation, 'cvv')) ? (
                    <ErrorMessage>
                        The credit card information you’ve entered is not valid
                    </ErrorMessage>
                ) : undefined}
            </StackLegacy>
        </div>
    );
}
